import {
  SUPER_ADMIN_ROLES,
  type SuperAdminRole
} from "../constants/authConstants";

export function isSuperAdminRole(
  role: string | null | undefined
): role is SuperAdminRole {
  return role != null && SUPER_ADMIN_ROLES.includes(role as SuperAdminRole);
}
